<template>
  <div id="app">
    <router-view>

    </router-view>
  </div>
</template>

<script>

  export default {
    name: 'App',
    created() {
      this.$messageBus.$on('coldwind', msgObj => {
        console.log(msgObj)
        if (msgObj && msgObj.message) {
          this.$notify.info({
            title: '通知',
            message: msgObj.message
          })
        }
      })
    },
    mounted() {
      let title='微析测试'
      if(this.projectName==='QYC'){
        title='微析测试'
      }else if(this.projectName==='YW'){
        title='甬微技术'
      }else if(this.projectName==='KYC'){
        title="微科测试"
      }else if(this.projectName==='WP'){
        title='微谱测试'
      }
      document.title = title +'后台管理系统'
    },
  }
</script>

<style>
  #app {
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue